import type CategoryType from "owa-service/lib/contract/CategoryType";
import { loc } from "owa-localize/lib/loc";
import { categoryNoneOption } from "../components/MailListJumpToPopover.locstring.json";

export const getJumpToCategoryOptions = (categoryList: CategoryType[]): {
    value: string;
    text: string;
}[] => {
    const categoryOptions: {
        value: string;
        text: string;
    }[] = [];
    
    categoryList.map(category => {
        if (category.Name) {
            categoryOptions.push({
                value: category.Name,
                text: category.Name,
            });
        }
    });
    
    categoryOptions.push({
        value: "",
        text: loc(categoryNoneOption),
    });
    
    return categoryOptions;
};
